import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AUTH } from "@/constants/testIds";
import { toast } from "sonner";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function Login() {
  usePageTitle("Sign in");
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await login(email, password); toast.success("Welcome back!"); nav(next); }
    catch (e) {
      const msg = e?.response?.data?.detail || "Login failed";
      setErr(msg); toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-20">
      <div className="w-full max-w-md mx-6">
        <div className="glass rounded-3xl p-8">
          <h1 className="font-display text-3xl tracking-tighter">Sign in</h1>
          <p className="mt-2 text-sm text-white/60">Welcome back to WeAutomate.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input data-testid={AUTH.loginEmail} type="email" required placeholder="Email"
                   value={email} onChange={(e) => setEmail(e.target.value)}
                   className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#9D4CDD]" />
            <input data-testid={AUTH.loginPassword} type="password" required placeholder="Password"
                   value={password} onChange={(e) => setPassword(e.target.value)}
                   className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#9D4CDD]" />
            {err && <div data-testid={AUTH.loginError} className="text-xs text-rose-300">{err}</div>}
            <button data-testid={AUTH.loginSubmit} disabled={busy}
                    className="w-full px-6 py-3 rounded-full gradient-bg font-medium disabled:opacity-50">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-6 text-sm text-white/60">
            New here? <Link to="/register" className="text-accent hover:text-white">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
